import { render, staticRenderFns } from "./blog-home-knowledge.vue?vue&type=template&id=dc7965b6&scoped=true"
import script from "./blog-home-knowledge.vue?vue&type=script&lang=js"
export * from "./blog-home-knowledge.vue?vue&type=script&lang=js"
import style0 from "./blog-home-knowledge.vue?vue&type=style&index=0&id=dc7965b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7965b6",
  null
  
)

export default component.exports